var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 18 18",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.58027 8.42877H5.42851C5.19104 8.42877 5 8.23773 5 8.00026V5.71487C5 5.54168 5.10356 5.38456 5.26425 5.3185C5.42494 5.25244 5.60884 5.28815 5.73204 5.41134L6.47479 6.15409C8.03886 4.60967 10.5581 4.61503 12.1133 6.17195C13.6756 7.73423 13.6756 10.266 12.1133 11.8283C10.551 13.3906 8.01922 13.3906 6.45694 11.8283C6.23375 11.6051 6.23375 11.2427 6.45694 11.0195C6.68012 10.7963 7.04257 10.7963 7.26575 11.0195C8.38166 12.1354 10.1903 12.1354 11.3063 11.0195C12.4222 9.90356 12.4222 8.09489 11.3063 6.97898C10.1957 5.86842 8.4013 5.86306 7.28361 6.96112L8.01743 7.69673C8.14063 7.81993 8.17634 8.00383 8.11027 8.16452C8.04421 8.32522 7.88709 8.42877 7.7139 8.42877H5.58027Z",
          fill: "#F10519",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }